import { sharedColors } from "ui/theme/colors"

const colors = {
  ...sharedColors,
  propBlue: "#25296D",
  heroBackgroundEn: "white",
  heroBackgroundHe: "white",
  heroTextColor: "black",
  heroSvgIconColor: "#25296D",
  filterModalHeaderColor: "rgba(255, 222, 0, 0.05)",
  filterModalHeaderTextColor: "#000",
  footerColor: "#25296D",
  faqRootBackground: "rgba(247, 247, 247, 1)",
  faqRootInsideBackground: "rgba(247, 247, 247, 1)",
  faqRootInsideBackgroundHover: "rgba(247, 247, 247, 1)",
  faqRootInsideColorHover: "#000",
  faqBorderColor: "rgba(247, 247, 247, 1)",
  faqTextColor: "#000",
  faqIconColor: "#000",
  faqIconColorAlternative: "#000",
  faqBoxShadow: "none",
  faqTextColorExpanded: "#FFF",
  faqTextColorHover: "#FFF",
  faqTitleBorderBottom: "#25296D",
  navBackgroundColor: "white",
  navTextColor: "black",
  selectedNavTextColor: "black",
  selectedSubNavTextColor: "black",
  selectedMobileNavTextColor: "black",
  footerSocialsBackgroundColor: "#25296D",
  footerLogoLinkBackgroundColor: "transparent",
  numberGridBackgroundColorEn: "linear-gradient(90deg, #25296D 0%, #1B1E4F 100%)",
  numberGridBackgroundColorHe: "linear-gradient(90deg, #1B1E4F 0%, #25296D 100%)",
  numberGridBorderColor: "rgba(37, 41, 109, 1)",
  newNumberGridTextColor: "#25296D",
  accordionPanelBackgroundColor: "rgba(37, 41, 109, 0.4)",
  jobsQuoteGalleryBackgroundColor: "rgba(37, 41, 109, 1)",
  teamContainerBackgroundColor: "rgba(37, 41, 109, 1)",
  buttonHoverBackgroundColor: "#25296D",
  buttonActiveBackgroundColor: "#25296D",
  buttonHoverTextColor: "white",
  paginationBackgroundColor: "#25296D",
  paginationTextColor: "white",
  bulletsBackgoundColor: "#25296D",
  jobCardTopHeader: "#000",
  heroBgFallback: "#25296D",
}

export default colors
